<template>
  <div
    :class="`project-structure-takt-time-selector ml-1 mr-1 ${active?'project-structure-takt-time-selector-active grey darken-2':''}`"
    >
    <!-- requestElementsByTakt({project_id: project_id, takt: 1}) -->
    <v-btn
      @click="$emit('clickActivator')"
      class="mr-1"
      :color="active?'green':''"
      :height="active?'30px':''"
      >
      4D
    </v-btn>
    <template v-if="active && current_takt_index !== false">
      <div>
        <div class="project-structure-takt-time-selector-cumulative">
          <v-icon
            @click="cumulative = !cumulative"
            >
            {{cumulative?'check_box':'check_box_outline_blank'}}
          </v-icon>
          <div>cumulative</div>
        </div>
        <div class="project-structure-takt-time-selector-takttime">
          <v-btn
            :disabled="takt === 1"
            :height="active?'30px':''"
            @click="takt--"
            >
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <div class="project-structure-takt-time-selector-input-wrapper elevation-2">
            <input
              class="project-structure-takt-time-selector-input"
              type="number"
              :value="takt"
              @change="changeTakt($event)"
            >
          </div>
          <v-btn
            :disabled="takt === project_length"
            :height="active?'30px':''"
            @click="takt++"
            >
            <v-icon>keyboard_arrow_right</v-icon>
          </v-btn>
        </div>
      </div>
    </template>
    <div class="project-structure-takt-time-selector-error" v-else-if="active">missing calendar or train</div>
  </div>
</template>
<script>
  export default {
    props: ['active', 'current_takt_index', 'project_length'],
    data: () => ({
      takt: 0,
      cumulative: false,
    }),
    created() {
      if (this.current_takt_index) {
        this.takt = this.current_takt_index + 1;
      }
    },
    watch: {
      takt: function() {
        if (this.active) {
          this.$emit('changeTakt', {takt_index: this.takt-1, cumulative: this.cumulative})
        }
      },
      active: function(val) {
        if (val) {
          this.$emit('changeTakt', {takt_index: this.takt-1, cumulative: this.cumulative})
        }
      },
      cumulative: function() {
        if (this.active) {
          this.$emit('changeTakt', {takt_index: this.takt-1, cumulative: this.cumulative})
        }
      }
    },
    methods: {
      changeTakt(evt) {
        if (evt.target.valueAsNumber < 1) {
          this.takt = 1;
        } else if (evt.target.valueAsNumber > this.project_length) {
          this.takt = this.project_length;
        } else {
          this.takt = evt.target.valueAsNumber;
        }
      }
    }
  }
</script>
<style>
  .project-structure-takt-time-selector {
    display: flex;
  }
  .project-structure-takt-time-selector-active {
    height: 60px;
    padding: 3px;
    border-radius: 3px;
    margin-top: -24px;
    align-items: flex-end;
  }
  .project-structure-takt-time-selector-input-wrapper {
    height: 30px;
    width: 64px;
    border-radius: 3px;
    background-color: #272727;
    margin: 0px 3px 0px 3px;
    padding: 3px;
  }
  .project-structure-takt-time-selector-input {
    width: 100%;
    text-align: center;
  }
  .project-structure-takt-time-selector-input:focus {
    outline: none;
  }
  .project-structure-takt-time-selector-error {
    width: 180px;
  }
  .project-structure-takt-time-selector-takttime {
    display: flex;
  }
  .project-structure-takt-time-selector-cumulative {
    display: flex;
  }
</style>
